import {
  messageStore,
  dialogStore,
  userStore,
  systemStore,
  auxillarySystemStore,
  appStore,
  taskStore,
  serviceStore,
  settingsStore,
  fileSystemStore,
  terminalStore,
  eventViewerStore,
} from './index';
import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { useObserver } from 'mobx-react-lite';

export const stores = {
  messageStore,
  dialogStore,
  userStore,
  systemStore,
  auxillarySystemStore,
  appStore,
  taskStore,
  serviceStore,
  settingsStore,
  fileSystemStore,
  terminalStore,
  eventViewerStore,
};

export const useStores = () => {
  return useContext<typeof stores>(MobXProviderContext);
};

export const useServicesStore = () => {
  const { serviceStore } = useStores();
  return useObserver(() => ({
    initServicesData: serviceStore.initServicesData,
    servicesData: serviceStore.servicesData,
  }));
};

export type Stores = typeof stores;
